import { RefObject, useEffect, useState } from 'react'

export type DropdownPosition = {
	vertical: 'top' | 'bottom'
	horizontal: 'left' | 'right'
	top?: number
	left?: number
}

/**
 * Хук для умного позиционирования дропдауна с порталом
 * Автоматически определяет оптимальную позицию и вычисляет абсолютные координаты
 */
export const useDropdownPosition = (
	isOpen: boolean,
	containerRef: RefObject<HTMLElement>,
	dropdownRef: RefObject<HTMLElement>,
): DropdownPosition => {
	const [position, setPosition] = useState<DropdownPosition>({
		vertical: 'bottom',
		horizontal: 'left',
	})

	useEffect(() => {
		if (!isOpen || !containerRef.current || !dropdownRef.current) return

		const containerRect = containerRef.current.getBoundingClientRect()
		const dropdownRect = dropdownRef.current.getBoundingClientRect()
		const viewportWidth = window.innerWidth
		const viewportHeight = window.innerHeight

		const gap = 8 // отступ между инпутом и дропдауном

		// Проверка вертикального позиционирования
		const spaceBelow = viewportHeight - containerRect.bottom
		const spaceAbove = containerRect.top
		const vertical = spaceBelow >= dropdownRect.height ? 'bottom' : 'top'

		// Проверка горизонтального позиционирования
		const spaceRight = viewportWidth - containerRect.left
		const spaceLeft = containerRect.right
		const horizontal = spaceRight >= dropdownRect.width ? 'left' : 'right'

		// Вычисление абсолютных координат для position: fixed
		let top: number
		if (vertical === 'bottom') {
			top = containerRect.bottom + gap
		} else {
			top = containerRect.top - dropdownRect.height - gap
		}

		let left: number
		if (horizontal === 'left') {
			left = containerRect.left
		} else {
			left = containerRect.right - dropdownRect.width
		}

		setPosition({ vertical, horizontal, top, left })
	}, [isOpen, containerRef, dropdownRef])

	return position
}
